import React, { useEffect } from "react"
import { VoterLoginForm } from "../../components/VoterLoginForm"
import { useIsAuthenticated } from "react-auth-kit"
import { useLocation, useNavigate } from "react-router-dom"

export const VoterLoginPage = () => {
  const isAuthenticated = useIsAuthenticated()
  const navigate = useNavigate()
  const location = useLocation()
  const notification = location.state?.notification

  useEffect(() => {
    if (notification) {
      // Clear the notification from the location state after it has been displayed
      navigate(location.pathname, {
        state: { ...location.state, notification: null },
        replace: true,
      })
    }
  }, [notification, location, navigate])

  useEffect(() => {
    if (isAuthenticated()) {
      navigate("/voter/dashboard", {
        state: { notification: "You are already logged in!" },
      })
    }
  }, [isAuthenticated, navigate])

  return <VoterLoginForm notification={notification} />
}
